
import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

import OfficeRoute from './Office';
import DashboardsRoutes from './Dashboards';
import ContractsRoutes from './Contracts';
import PaymentPlanRoutes from './PaymentPlan';
import DocumentsRoutes from './Documents';
import OperationalRoutes from './Operational';

const TaxClaimants = lazy(() => import(`Pages/Screens/Office/TaxClaimant/Page`));
const Clients = lazy(() => import(`Pages/Screens/Office/Clients/Page`));
const Departments = lazy(() => import(`Pages/Screens/Office/Departments/Page`));

const OfficeRoutes = [
    ...OfficeRoute,
    ...DashboardsRoutes,
    ...ContractsRoutes,
    ...PaymentPlanRoutes,
    ...DocumentsRoutes,
    ...OperationalRoutes,
    {
        path: 'taxclaimant',
        element: <LoadComponent component={TaxClaimants} />,
    },
    {
        path: 'client',
        element: <LoadComponent component={Clients} />,
    },
    {
        path: 'departments',
        element: <LoadComponent component={Departments} />,
    },
]

export default OfficeRoutes;